module.exports = __webpack_public_path__ + "img/1822844.png";